module.exports = __webpack_public_path__ + "static/media/country_pn.43ca0670.webp";